/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_LanguageInputs */

const en_field_language = /** @type {(inputs: Field_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary Language`)
};

const es_field_language = /** @type {(inputs: Field_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma principal`)
};

const fr_field_language = /** @type {(inputs: Field_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue principale`)
};

const de_field_language = /** @type {(inputs: Field_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauptsprache`)
};

const ja_field_language = /** @type {(inputs: Field_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主な言語`)
};

const zh_field_language = /** @type {(inputs: Field_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主要语言`)
};

const ar_field_language = /** @type {(inputs: Field_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللغة الأساسية`)
};

const id_field_language = /** @type {(inputs: Field_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Utama`)
};

const it_field_language = /** @type {(inputs: Field_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua Principale`)
};

const ru_field_language = /** @type {(inputs: Field_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основной язык`)
};

const pt_field_language = /** @type {(inputs: Field_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma Principal`)
};

const ko_field_language = /** @type {(inputs: Field_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주요 언어`)
};

/**
* | output |
* | --- |
* | "Primary Language" |
*
* @param {Field_LanguageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_language = /** @type {((inputs?: Field_LanguageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_LanguageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_language(inputs)
	if (locale === "es") return es_field_language(inputs)
	if (locale === "fr") return fr_field_language(inputs)
	if (locale === "de") return de_field_language(inputs)
	if (locale === "ja") return ja_field_language(inputs)
	if (locale === "zh") return zh_field_language(inputs)
	if (locale === "ar") return ar_field_language(inputs)
	if (locale === "id") return id_field_language(inputs)
	if (locale === "it") return it_field_language(inputs)
	if (locale === "ru") return ru_field_language(inputs)
	if (locale === "pt") return pt_field_language(inputs)
	return ko_field_language(inputs)
});